import PropTypes from "prop-types";

import { pollQuestionProptype } from "@/view/PollContainer/PollProptypes";
import usePollContext from "@/view/utils/usePollContext";
import { countWrapperCss } from "./PollResponseCount.style";

const propTypes = {
  isStudent: PropTypes.bool,
  pollData: pollQuestionProptype.isRequired,
};

const PollResponseCount = ({ isStudent, pollData }) => {
  const totalVotes = pollData.total_votes;
  const { totalPollAssignees } = usePollContext();

  if (isStudent) {
    const isMultiple = totalVotes > 1;
    const totalVotesString = `${totalVotes} total vote${isMultiple ? "s" : ""}`;

    return <div css={countWrapperCss}>{totalVotesString}</div>;
  } else {
    return (
      <div css={countWrapperCss}>
        {totalVotes} of {totalPollAssignees} responses
      </div>
    );
  }
};

PollResponseCount.propTypes = propTypes;

export default PollResponseCount;
